import type { Invoice } from "~/shared/schemas/invoice-schema";

export type InvoiceStatusDisplayDetails = {
	className: string;
	text: string;
	url: string;
};

const NOT_AVAILABLE: InvoiceStatusDisplayDetails = {
	className: "not-available",
	text: "N/A",
	url: "",
};

const INVOICE_STATUS_MAPPINGS: Record<string, InvoiceStatusDisplayDetails> = {
	"ready for payment": {
		className: "ready-for-payment",
		text: "Ready for Payment",
		url: "",
	},
	"payment pending": {
		className: "payment-pending",
		text: "Payment Pending",
		url: "",
	},
	"payment required": {
		className: "payment-required",
		text: "Payment Required",
		url: "",
	},
	"pre-payment received": {
		className: "pre-payment-received",
		text: "Pre-Payment Received",
		url: "",
	},
	paid: {
		className: "paid",
		text: "Paid",
		url: "",
	},
	"past-due": {
		className: "past-due",
		text: "Past Due",
		url: "",
	},
};

export const getInvoiceStatusDisplayDetails = (
	item: Invoice,
): InvoiceStatusDisplayDetails => {
	if (!item.invoiceStatus) return NOT_AVAILABLE;
	return (
		INVOICE_STATUS_MAPPINGS[item.invoiceStatus.toLowerCase()] ?? NOT_AVAILABLE
	);
};
